import { render, staticRenderFns } from "./ListQuestion.vue?vue&type=template&id=5221f405&scoped=true"
import script from "./ListQuestion.vue?vue&type=script&lang=js"
export * from "./ListQuestion.vue?vue&type=script&lang=js"
import style0 from "./ListQuestion.vue?vue&type=style&index=0&id=5221f405&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5221f405",
  null
  
)

export default component.exports